import React, { Component } from "react";
import { Form, Layout, Button, Row, Col, Popconfirm, Table, Tag } from "antd";
import "./index.scss";
import CreateUpdateModal from "./components/CreateUpdateModal";
import { checkPermission } from "../../utils/helper";
import { Redirect } from "react-router-dom";


const { Content } = Layout;

class User extends Component {
  initialState = {
    usersData: [],
    showCreateUpdateModal: false,
    selectedRow: {}
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  handleCreateButton = () => {
    this.setState({
      showCreateUpdateModal: true
    });
  };

  handleUpdateButton = (row) => {
    this.setState({
      showCreateUpdateModal: true,
      selectedRow: row
    });
  };

  handleDeleteButton = (row) => {
    this.props.onDeleteUser(row);
  }

  handleCloseModal = () => {
    this.setState({
      showCreateUpdateModal: false,
    });
  };

  componentDidMount() {
    const onGetParam = {
      event_id: this.props.event.id
    };
    this.props.onGetUsers(onGetParam);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.usersData !== nextProps.usersData) {
      this.setState({ usersData: nextProps.usersData });
    }
  }

  render() {
    const { usersData, showCreateUpdateModal, selectedRow } = this.state;
    const { isLoading, } = this.props;
    const module = "user";

    if (!checkPermission(module, "view")) {
      return (<Redirect to="/403" />);
    }

    const columns = [
      {
        title: 'Email Address',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Username',
        dataIndex: 'username',
        key: 'username',
      },
      {
        title: 'Name',
        dataIndex: 'first_name',
        key: 'first_name',
        render: (column, row) => (
          <span>{`${row.first_name} ${row.last_name}`}</span>
        )
      },
      {
        title: 'User Role',
        dataIndex: 'user_role_id',
        key: 'user_role_id',
        align: 'center',
        render: (column, record) => (
          <span>{record.role && record.role.role_name ? record.role.role_name : ''}</span>
        )
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        render: status => (
          <span>
            {status == 1 ?
              (
                <Tag color='green' key='active'>
                  Active
                </Tag>
              ) : (
                <Tag color='gray' key='inactive'>
                  Inactive
                </Tag>
              )
            }
          </span>
        ),
      },
      {
        title: 'Action',
        key: 'action',
        align: 'center',
        render: (text, record) => (
          <span>
            {(checkPermission(module, "edit")) ?
              <Button type="default" onClick={() => this.handleUpdateButton(record)}>Edit</Button> : ''
            }
            &nbsp;&nbsp;
            {/* <Divider type="vertical" /> */}
            {(checkPermission(module, "delete")) ?
              <Popconfirm
                title="Are you sure you want to delete?"
                onConfirm={() => this.handleDeleteButton(record)}
                okText="Proceed"
                cancelText="Cancel"
              >
                <Button type="danger">Delete</Button>
              </Popconfirm> : ''
            }
          </span>
        ),
      },
    ];

    return (
      <Layout className="user-container">
        <Content className="user-content" style={{ padding: "20px 60px" }}>
          <Row type="flex" gutter={30}>
            <Col span={24}>
              <h2>Users</h2>
            </Col>
          </Row>

          <Row type="flex" gutter={30}>
            <Col span={12} className="page-content-control-button-holder">
              {(checkPermission(module, "create")) ?
                <Button type="primary" loading={isLoading} onClick={this.handleCreateButton}>Add User</Button>
                : ''
              }
            </Col>
          </Row>

          <Row type="flex" gutter={30}>
            <Col span={24}>
              <Table columns={columns} dataSource={usersData} loading={isLoading} rowKey={"id"} />
            </Col>
          </Row>
        </Content>

        <CreateUpdateModal showModal={showCreateUpdateModal} selectedRow={selectedRow} handleCloseModal={this.handleCloseModal} {...this.props} />
      </Layout>
    );
  }
}

const UserForm = Form.create({ name: "user-form" })(User);

export default UserForm;
